// client/src/routes/_auth/mfa_.enroll.tsx — SCR-AUTH-004 „Înrolare MFA (TOTP)" · AUTH-004.
//
// 04 §8.1: "both the forced-enrollment flow (mandatory for `admin`) and the target of
// SCR-SET-002's „Activează MFA"". Two ways in, then: a pending challenge that owes enrollment
// (no session yet), or a signed-in user opting in. Neither may be turned away; a visitor with
// neither has nothing to enroll and goes to the password.
//
// ── the file name ends in `mfa_`, and that underscore is load-bearing ──────────────────────
// As `mfa.enroll.tsx` this route was generated as a CHILD of `/_auth/mfa`, so every
// navigation here ran that route's `beforeLoad` first — which sends a pending challenge that
// owes enrollment to `/mfa/enroll`, which matched this same parent again. „Too many
// redirects", on the one path a platform admin cannot avoid: MFA is mandatory for them, so a
// first login could not get past it. The trailing underscore is TanStack's opt-out from
// nesting: the URL stays `/mfa/enroll` and this file's guard is the only one that runs
// (D-1744). `mfa.tsx` renders `MfaChallenge` with no `<Outlet />`, so the nesting could never
// have rendered this screen even without the loop.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { MfaEnroll } from '@/features/auth/MfaEnroll';
import { forwardRedirect, redirectSearchSchema } from '@/features/auth/redirect';
import { ensureSession } from '@/session';
import { useAuthStore } from '@/stores/auth-store';

export const Route = createFileRoute('/_auth/mfa_/enroll')({
  validateSearch: redirectSearchSchema,
  beforeLoad: async ({ search }) => {
    const session = await ensureSession();
    const pending = useAuthStore.getState().pendingMfa;

    if (session?.mfaEnabled) throw redirect({ to: '/app/settings/security' });
    if (!session && !pending?.enrollmentRequired) {
      throw redirect({ to: '/login', search: forwardRedirect(search) });
    }
  },
  component: MfaEnrollScreen,
});

function MfaEnrollScreen() {
  const search = Route.useSearch();
  return <MfaEnroll search={search} />;
}
